export interface EventMasterCategorySeed {
  event_type_code: string;
  category_code: string;
  category_name: string;
  description: string;
  default_display_order: number;
  is_active: boolean;
  items: EventMasterItemSeed[];
}

export interface EventMasterItemSeed {
  item_code: string;
  item_name: string;
  description: string;
  default_unit: string;
  default_dimension_text: string;
  default_unit_rate: number;
  pricing_mode: "manual" | "quantity_x_rate";
  is_active: boolean;
}

export const eventMasterSeed: EventMasterCategorySeed[] = [
  {
    event_type_code: "WEDDING",
    category_code: "WEDDING_DECOR",
    category_name: "Wedding Decor",
    description: "Wedding, reception, mandap, entrance, stage and guest area decoration services.",
    default_display_order: 10,
    is_active: true,
    items: [
      {
        item_code: "WED-STAGE-001",
        item_name: "Premium Wedding Stage Backdrop",
        description: "Custom themed reception or wedding stage backdrop with artificial floral styling and warm lighting.",
        default_unit: "setup",
        default_dimension_text: "1 complete setup",
        default_unit_rate: 45000,
        pricing_mode: "manual",
        is_active: true
      },
      {
        item_code: "WED-MANDAP-002",
        item_name: "Mandap Floral Setup",
        description: "Decorative mandap setup with pillars, drapes, floral hangings and coordinated theme elements.",
        default_unit: "setup",
        default_dimension_text: "1 mandap",
        default_unit_rate: 65000,
        pricing_mode: "manual",
        is_active: true
      },
      {
        item_code: "WED-ENT-003",
        item_name: "Wedding Entrance Arch",
        description: "Welcome entrance arch with flowers, drapes, props and guest-facing styling.",
        default_unit: "setup",
        default_dimension_text: "1 entrance",
        default_unit_rate: 18000,
        pricing_mode: "manual",
        is_active: true
      },
      {
        item_code: "WED-AISLE-004",
        item_name: "Aisle Pathway Decor",
        description: "Aisle pathway decoration with stands, florals, candles or lamps as per theme.",
        default_unit: "setup",
        default_dimension_text: "Up to 100 ft",
        default_unit_rate: 22000,
        pricing_mode: "manual",
        is_active: true
      },
      {
        item_code: "WED-PHOTO-005",
        item_name: "Couple Photo Booth",
        description: "Photo booth corner with backdrop, props, floral accents and decorative lighting.",
        default_unit: "setup",
        default_dimension_text: "1 booth",
        default_unit_rate: 25000,
        pricing_mode: "manual",
        is_active: true
      },
      {
        item_code: "WED-TABLE-006",
        item_name: "Guest Table Centerpieces",
        description: "Artificial floral table centerpieces for guest seating or dinner tables.",
        default_unit: "table",
        default_dimension_text: "Per table",
        default_unit_rate: 1500,
        pricing_mode: "quantity_x_rate",
        is_active: true
      }
    ]
  },
  {
    event_type_code: "BIRTHDAY",
    category_code: "BIRTHDAY_DECOR",
    category_name: "Birthday Decor",
    description: "Birthday backdrop, balloon, cake table, kids theme and party decoration services.",
    default_display_order: 20,
    is_active: true,
    items: [
      {
        item_code: "BDAY-BACKDROP-001",
        item_name: "Birthday Theme Backdrop",
        description: "Theme-based backdrop with name, age number, graphics and decorative styling.",
        default_unit: "setup",
        default_dimension_text: "8 ft x 8 ft",
        default_unit_rate: 18000,
        pricing_mode: "manual",
        is_active: true
      },
      {
        item_code: "BDAY-BALLOON-002",
        item_name: "Balloon Garland Decoration",
        description: "Balloon garland in selected colors with chrome or pastel combinations as per theme.",
        default_unit: "setup",
        default_dimension_text: "Up to 20 ft",
        default_unit_rate: 12000,
        pricing_mode: "manual",
        is_active: true
      },
      {
        item_code: "BDAY-CAKE-003",
        item_name: "Cake Table Setup",
        description: "Decorated cake table with cloth, props, risers and table styling.",
        default_unit: "setup",
        default_dimension_text: "1 table",
        default_unit_rate: 6500,
        pricing_mode: "manual",
        is_active: true
      },
      {
        item_code: "BDAY-CUTOUT-004",
        item_name: "Name Cutout & Age Number",
        description: "Customized child name cutout and age number for birthday theme display.",
        default_unit: "setup",
        default_dimension_text: "Name + age number",
        default_unit_rate: 4500,
        pricing_mode: "manual",
        is_active: true
      },
      {
        item_code: "BDAY-KIDS-005",
        item_name: "Kids Welcome Board",
        description: "Customized welcome board matching birthday theme and color palette.",
        default_unit: "unit",
        default_dimension_text: "1 board",
        default_unit_rate: 3500,
        pricing_mode: "manual",
        is_active: true
      },
      {
        item_code: "BDAY-PROP-006",
        item_name: "Theme Props Package",
        description: "Theme props package for cartoons, jungle, princess, space or custom birthday concepts.",
        default_unit: "package",
        default_dimension_text: "Standard prop set",
        default_unit_rate: 10000,
        pricing_mode: "manual",
        is_active: true
      }
    ]
  },
  {
    event_type_code: "OTHER",
    category_code: "TRADITIONAL_EVENTS",
    category_name: "Traditional Events",
    description: "Traditional ceremony, pooja, engagement, festival and cultural event decoration services.",
    default_display_order: 30,
    is_active: true,
    items: [
      {
        item_code: "TRAD-ENT-001",
        item_name: "Traditional Entrance Decor",
        description: "Traditional entrance with toran, flowers, fabric, lamps and cultural styling.",
        default_unit: "setup",
        default_dimension_text: "1 entrance",
        default_unit_rate: 15000,
        pricing_mode: "manual",
        is_active: true
      },
      {
        item_code: "TRAD-STAGE-002",
        item_name: "Traditional Stage Backdrop",
        description: "Stage or ceremony backdrop with ethnic fabric, floral details and warm lights.",
        default_unit: "setup",
        default_dimension_text: "1 backdrop",
        default_unit_rate: 28000,
        pricing_mode: "manual",
        is_active: true
      },
      {
        item_code: "TRAD-POOJA-003",
        item_name: "Pooja Setup Decoration",
        description: "Pooja area styling with backdrop, chowki decor, flowers and diya arrangement.",
        default_unit: "setup",
        default_dimension_text: "1 pooja setup",
        default_unit_rate: 22000,
        pricing_mode: "manual",
        is_active: true
      },
      {
        item_code: "TRAD-DIYA-004",
        item_name: "Diya & Floral Pathway",
        description: "Pathway styling with diya placement, floral borders and traditional accents.",
        default_unit: "setup",
        default_dimension_text: "Up to 60 ft",
        default_unit_rate: 12000,
        pricing_mode: "manual",
        is_active: true
      },
      {
        item_code: "TRAD-WELCOME-005",
        item_name: "Traditional Welcome Board",
        description: "Welcome board with traditional motif, client/event name and theme styling.",
        default_unit: "unit",
        default_dimension_text: "1 board",
        default_unit_rate: 3500,
        pricing_mode: "manual",
        is_active: true
      },
      {
        item_code: "TRAD-FLOWER-006",
        item_name: "Loose Floral Decoration",
        description: "Loose flower, garland and floral accent styling for traditional ceremony areas.",
        default_unit: "package",
        default_dimension_text: "Standard floral package",
        default_unit_rate: 18000,
        pricing_mode: "manual",
        is_active: true
      }
    ]
  }
];
